import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "pressed", "today"];
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { DatePickerButtonMixin } from '../../mixins/components/DatePickerButtonMixin';
import Button from '../Button/Button';
var DatePickerButtonComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      pressed = _ref.pressed,
      today = _ref.today,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({
    ref: ref || undefined,
    "aria-pressed": pressed ? true : undefined
  }, props), children);
});
DatePickerButtonComponent.displayName = 'DatePickerButton';
var DatePickerButton = /*#__PURE__*/styled(DatePickerButtonComponent).withConfig({
  displayName: "DatePickerButton",
  componentId: "c11n-8-64-0__sc-1kgb29d-0"
})(["", ""], DatePickerButtonMixin);
DatePickerButton.propTypes = {
  children: PropTypes.node,
  pressed: PropTypes.bool,
  today: PropTypes.bool,

  /** @ignore */
  buttonType: PropTypes.string,

  /** @ignore */
  borderless: PropTypes.bool,

  /** @ignore */
  size: PropTypes.string
};
DatePickerButton.defaultProps = {
  children: null,
  pressed: false,
  today: false,
  buttonType: 'tertiary',
  borderless: true,
  size: 'sm'
};
DatePickerButtonComponent.propTypes = DatePickerButton.propTypes;
export default DatePickerButton;